<script>
/**
 * Alert
 */
export default {
    name: "modal-header",
    props: {
        text: {
            default: "",
            required: false,
        },
        isDrag: {
            default: true,
            required: false,
            type: Boolean,
        },
        icon: {
            default: "&#xe693;",
            required: false,
        },
        isHideClose: {
            default: false,
            required: false,
            type: Boolean,
        },
        closeIcon: {
            default: "&#xe6a4;",
            required: false,
        },
        destroy: {
            type: Function,
        },
    },
    data() {
        return {
            isStartDrag: false,
            startX: 0,
            startY: 0,
            modalX: 0,
            modalY: 0,
        };
    },
    methods: {
        onDestroy() {
            if (this.destroy) {
                this.destroy();
            } else {
                this.$emit("close");
                this.$parent.close();
            }
        },
        handleStartDrag($e) {
            this.isStartDrag = true;
            this.startX = $e.pageX;
            this.startY = $e.pageY;
            const react = this.$refs.header.getBoundingClientRect();
            this.modalX = react.left;
            this.modalY = react.top + document.scrollingElement.scrollTop;
            this.limitSX = 50 - react.width;
            this.limitEX = document.documentElement.clientWidth - 50;
            this.limitSY = -25;
            this.limitEY = document.documentElement.clientHeight - 50;
            this.$pel = this.$parent.$el;
            this.position = window.getComputedStyle(this.$pel).position;
            const scrollLeft = document.scrollingElement.scrollLeft;
            const scrollTop = document.scrollingElement.scrollTop;
            this.stepX = this.position === "fixed" ? -scrollLeft : scrollLeft;
            this.stepY = this.position === "fixed" ? -scrollTop : scrollTop;
            if (this.position === "absolute") {
                this.limitSY = scrollTop - 25;
                this.limitEX += this.stepX;
                this.limitEY += this.stepY;
            }
            document.body.classList.add("all-no-select");
        },
        handleEndDrag() {
            this.isStartDrag = false;
            this.startY = 0;
            this.startX = 0;
            this.modalX = 0;
            this.modalY = 0;
            document.body.classList.remove("all-no-select");
        },
        handleMoveDrag($e) {
            if (!this.isStartDrag) {
                return;
            }
            const x = $e.pageX;
            const y = $e.pageY;
            let moveX = x - this.startX + this.modalX + this.stepX;
            let moveY = y - this.startY + this.modalY;
            if (this.position === "fixed") {
                moveY = moveY + this.stepY;
            }
            if (moveX < this.limitSX) {
                moveX = this.limitSX;
            } else if (moveX > this.limitEX) {
                moveX = this.limitEX;
            } else if (moveY < this.limitSY) {
                moveY = this.limitSY;
            } else if (moveY > this.limitEY) {
                moveY = this.limitEY;
            }

            this.$pel.style.margin = `0`;
            this.$pel.style.top = `${moveY}px`;
            this.$pel.style.left = `${moveX}px`;
        },
    },
    computed: {
        curStyle() {
            return {
                cursor: this.isDrag ? "move" : "default",
            };
        },
    },
    beforeDestroy() {
        if (this.isDrag) {
            window.removeEventListener("mousemove", this.handleMoveDrag);
            window.removeEventListener("mouseup", this.handleEndDrag);
        }
    },
    mounted() {
        if (this.isDrag) {
            window.addEventListener("mousemove", this.handleMoveDrag);
            window.addEventListener("mouseup", this.handleEndDrag);
        }
    },
};
</script>

<template>
    <div
        class="modal-header"
        :style="curStyle"
        ref="header"
        @mousedown="handleStartDrag"
        @mouseup.stop="handleEndDrag"
        @mousemove.stop="handleMoveDrag"
    >
        <div class="icon left" v-html="icon"></div>
        <div v-if="text" class="text left" v-html="text"></div>
        <div v-else class="text left">
            <slot />
        </div>
        <slot name="opts"></slot>
        <!--<div class="text left" v-html="text ? text : $slots.default[0].text"></div>-->
        <div class="close right" v-if="!isHideClose" @click="onDestroy">
            <span v-html="closeIcon"></span>
        </div>
    </div>
</template>

<style lang="less" scoped>
@import "../../assets/less/widgets-var.less";

.modal-header {
    height: 54px;
    width: 100%;
    box-sizing: border-box;
    padding: 0 15px 0 30px;
    font-size: @fontSizeContent;
    border-bottom: 1px solid @otherBorderClr;
    background-color: @whiteBg;

    * {
        box-sizing: border-box;
    }

    > * {
        line-height: 54px;
        font-family: cmsicon;
    }

    .icon {
        color: @primaryBg;
        margin-right: 10px;
    }

    .close {
        cursor: pointer;
        padding: 0 15px;
        color: @otherBtnBorderNoteClr;
    }
}
</style>
